
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.57 5.62L10 2.64 3.43 5.62 10 8.6l6.57-2.98z","stroke":"currentColor","stroke-width":"2"}}),_c('path',{attrs:{"d":"M17.158 10l-6.845 3.105c-.2.091-.426.091-.626 0L2.842 10M17.158 14.449l-6.845 3.105c-.2.09-.426.09-.626 0L2.842 14.45","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round"}})])
          )
        }
      }
    